import React, { ReactElement } from "react";
import APIService from "../../services/API";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}

interface Message {
    message: string;
}

export default function Private({}: Props): ReactElement {
    const [messages, setMessages] = React.useState<Message[]>([]);
    React.useEffect(() => {
        APIService.HandleGetRequest("/messages").then((res) => {
            setMessages(res as Message[]);
        });
    }, []);
    return (
        <div>
            {messages.map((mess: Message, index: number) => (
                <div key={index}>{mess.message}</div>
            ))}
        </div>
    );
}
